module.exports = __webpack_public_path__ + "static/img/facebook.4f580810.svg";